import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsBadgeModule,
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsRadioModule,
} from '@cmps/ng-uikit';

import { CmpsCommentModule } from '../../../evaluation/comment';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsLocalCallModule } from '../../../local-call';
import { CmpsTeamsCallModule } from '../../../teams-call';

import { CaGuidePickerDialogComponent } from './ca-guide-picker-dialog.component';
import { TranslationIdMap as DialogTranslationIdMap } from './ca-guide-picker-dialog.component.i18n';
import { GuideCardComponent } from './component/guide-card/guide-card.component';
import { TranslationIdMap as CardTranslationIdMap } from './component/guide-card/guide-card.component.i18n';

@NgModule({
    declarations: [CaGuidePickerDialogComponent, GuideCardComponent],
    exports: [CaGuidePickerDialogComponent],
    imports: [
        CmpsBadgeModule,
        CmpsButtonModule,
        CmpsCommentModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsRadioModule,
        CmpsLazyI18nModule.forChild(CardTranslationIdMap),
        CmpsLazyI18nModule.forChild(DialogTranslationIdMap),
        CmpsLocalCallModule,
        CmpsTeamsCallModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class CmpsCaGuideDialogPickerModule {}
